import { Action, createReducer, on } from '@ngrx/store';

import * as actions from './shared-audit.actions';
import { AuditScreen } from '../audit-screen.enum';

export interface State {
  enableAudit: boolean;
  showAuditDrawer: boolean;
  auditScreen: AuditScreen | null;
  auditScreens: AuditScreen[] | null;
  selectedAuditScreen: AuditScreen | null;
}

export const initialState: State = {
  enableAudit: false,
  showAuditDrawer: false,
  auditScreen: null,
  auditScreens: null,
  selectedAuditScreen: null
};

const sharedAuditReducer = createReducer<State>(
  initialState,
  on(actions.EnableAudit, (state, action) => {
    if (action.auditScreen) {
      return {
        ...state,
        enableAudit: true,
        auditScreen: action.auditScreen,
        auditScreens: null
      };
    }
    if (action.auditScreens) {
      return {
        ...state,
        enableAudit: true,
        auditScreen: null,
        auditScreens: action.auditScreens
      };
    }
    return state;
  }),

  on(actions.DisableAudit, state => ({
    ...state,
    enableAudit: false,
    auditScreen: null,
    auditScreens: null,
    selectedAuditScreen: null
  })),

  on(actions.ShowAuditDrawer, state => ({
    ...state,
    showAuditDrawer: true
  })),

  on(actions.HideAuditDrawer, state => ({
    ...state,
    showAuditDrawer: false
  })),

  on(actions.SelectAuditScreen, (state, action) => ({
    ...state,
    selectedAuditScreen: action.selectedAuditScreen
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return sharedAuditReducer(state, action);
}
